export const getDefaultStyles = (element) => {
  const getStyle = window.getComputedStyle(element);
  const fontFamily = getStyle.getPropertyValue('--app-font-family').split(",")[0];

  return {
    primaryColor: getStyle.getPropertyValue('--primary-color').toLowerCase(),
    primarySemiLightColor: getStyle.getPropertyValue('--primary-semi-light-color').toLowerCase(),
    primaryLightColor: getStyle.getPropertyValue('--primary-light-color').toLowerCase(),
    secondaryColor: getStyle.getPropertyValue('--secondary-color').toLowerCase(),
    secondaryLightColor: getStyle.getPropertyValue('--secondary-light-color').toLowerCase(),
    rejectButtonColor: getStyle.getPropertyValue('--reject-button-color').toLowerCase(),
    fontFamily: fontFamily[0] === '"' ? fontFamily.slice(1, -1) : fontFamily,
    backgroundColor: "#ffffff",
    textColor: "#212529",
  };
};
